import { render, staticRenderFns } from "./dashboardLayout.vue?vue&type=template&id=3a1c3d46&scoped=true&"
import script from "./dashboardLayout.vue?vue&type=script&lang=js&"
export * from "./dashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c3d46",
  null
  
)

export default component.exports